import React from 'react';

interface CheckboxOptionProps {
  name: string;
  value: string;
  label: string;
  registerProps?: Record<string, unknown>;
}

export default function CheckboxOption({
  name,
  value,
  label,
  registerProps,
}: CheckboxOptionProps) {
  return (
    <label
      className="flex items-center gap-3 rounded-lg px-4 py-3 cursor-pointer transition-all duration-150 border"
      style={{
        borderColor: 'var(--border)',
        backgroundColor: 'var(--card)',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLLabelElement).style.backgroundColor =
          'var(--background)';
        (e.currentTarget as HTMLLabelElement).style.borderColor =
          'var(--secondary)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLLabelElement).style.backgroundColor =
          'var(--card)';
        (e.currentTarget as HTMLLabelElement).style.borderColor =
          'var(--border)';
      }}
    >
      <input
        type="checkbox"
        name={name}
        value={value}
        className="w-4 h-4 flex-shrink-0 rounded"
        style={{ accentColor: 'var(--primary)' }}
        {...registerProps}
      />
      <span className="text-sm leading-snug">{label}</span>
    </label>
  );
}